@if (content) {
<div class="pos-relative p-t-15 p-b-5">

    <!-- Close Button -->
    <a class="pos-absolute top-5 right-5 z-2"
       [routerLink]="'/account/my-missions'">
        <i class="icon-close"></i>
    </a>


    <!-- Carousel Dots -->
    <div class="_swiperPagination"></div>

    <!-- Carousel -->
    <carousel class="_firstMissionCarousel flex-grow"
              [pagination]="{
                            el: '._swiperPagination',
                            clickable: false
                        }"
              [slidesPerView]="1"
              [allowTouchMove]="false"
              (afterInit)="onAfterSwiperInit($event)">

        <!-- Selection Step -->
        <ng-template swiperSlide>
            <div class="height-100 flex-column wrap flex-middle">
                <!-- User Icon -->
                <div class="bg-col-5 b-radius-max box-shadow-1 m-t-3">
                    <i [ngClass]="content.userIcon"
                       class="p-a-2 inline-flex"
                       style="font-size: 24px;"></i>
                </div>

                <h1 *iCms="'title' of content"
                    class="h3 m-t-3"></h1>
                <p *iCms="'subtitle' of content"
                   class="s2 m-t-5"></p>


                <!-- Options Grid -->
                <div class="flex flex-wrap flex-justify-center m-t-7"
                     style="gap: 6px;">
                    @for (option of content.options; track $index) {
                    <div class="flex flex-justify-center"
                         [ngClass]="content.options.length % 2 !== 0 && $first ? 'w-12' : 'w-5'">
                        <button class="_optionButton p-a"
                                [class._selected]="isOptionSelected(option.label)"
                                (click)="toggleOption(option.label)">

                            <i [ngClass]="option.icon"
                               class="inline-flex"
                               style="font-size: 28px;"></i>

                            <span class="p2">{{ option.label }}</span>
                            <div class="_optionTick">
                                <i class="icon-tick"></i>
                            </div>
                        </button>
                    </div>
                    }
                </div>

                <!-- Save Button -->
                <div class="m-t-10 p-t-8 w-12">
                    <action class="button w-12"
                            [status]="saveStatus"
                            (click)="saveSelection()">
                        <span *iCms="'saveButtonText' of content"></span>
                    </action>
                    <!--
                  Hide error message, Jakub request from LER-5341
                  <result [status]="saveStatus"></result> -->
                </div>
            </div>
        </ng-template>

        <!-- Success Step -->
        <ng-template swiperSlide>
            <mission-success [mission]="mission"
                             [content]="content"
                             class="height-100 wrap">
            </mission-success>
        </ng-template>

    </carousel>
</div>
}
